import React, {PureComponent} from 'react';
import {inject, observer} from 'mobx-react';
import {ArticlesStore} from 'app/store/ArticlesStore';
import {isDesktop, newsArticles} from 'app/utils';
import LetsShow from 'app/components/pages/LetsShow';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';

interface LetsShowNewsProps {
    articlesStore?: ArticlesStore
}

const HALF_COUNT = 2;

@inject('articlesStore')
@observer
export default class LetsShowNews extends PureComponent<LetsShowNewsProps> {
    constructor(props: LetsShowNewsProps) {
        super(props);
        this.props.articlesStore.loadPinnedArticles();
    }

    splitInHalf = (data: ArticleInterface[]): [ArticleInterface[], ArticleInterface[]] => {
        const half = Math.ceil(data.length / HALF_COUNT);
        const firstHalf = data.slice(0, half);
        const secondHalf = data.slice(half);
        return [firstHalf, secondHalf];
    };

    render(): React.ReactNode {
        const {articlesStore} = this.props;
        const articles = newsArticles(articlesStore.pinnedArticles);
        const [left, right] = isDesktop() ? this.splitInHalf(articles) : [articles, []];
        return articles.length > 0 && <LetsShow
            loadArticles={articlesStore.loadMainArticles}
            data_left={left}
            type_left="news"
            nameForControls_left="news_left"
            data_right={right}
            type_right="news"
            nameForControls_right="news_right"
        />;
    }
}
